import MobileStepper from '@mui/material/MobileStepper'
import Stepper from '@mui/material/Stepper'
import Step from '@mui/material/Step'
import StepLabel from '@mui/material/StepLabel'

import Box from '@mui/material/Box'

import { positionChangeWidthSm, ministepsHeight } from './variableDefaults'


// Standardized mobile stepper used in onboarding process
export const mobileStepperElement = (activeStep, steps, color, marginBottom, margingTop, maxWidth) => {
  return (
    <Box
      sx={{
        height: ministepsHeight,
        width: '100%',
        mb: 2, mt: 2,
        display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center',
      }}
    >
      <MobileStepper
        variant="dots"
        steps={steps}
        position="static"
        activeStep={activeStep}
        sx={{ maxWidth: maxWidth, mb: marginBottom, mt: margingTop, 
          bgcolor: 'transparent', 
          color: color, 
        }}
      />
    </Box>
  )
}

export const stepperElement = (bottomSteps, activeBottomStep, width, paddingBottom = 0, paddingTop = 0) => {
  return (
    <Box 
      sx={{ width: '100%', pb: paddingBottom, 
        // backgroundColor: 'orange',
        pt: paddingTop, 
      }}
    >
      <Stepper alternativeLabel activeStep={activeBottomStep} >
        {bottomSteps.map((label) => (
          <Step key={label}> 
            <StepLabel>
              {/* {width >= positionChangeWidthSm ? label : ''} */}
              {width >= positionChangeWidthSm ? label : label}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  )
}